var map = {
	"./denim_wash_shirt.jpg": "57c6",
	"./plaid_shirt.jpg": "8acc",
	"./raglan_tee.jpg": "5732",
	"./rugby_jersey.jpg": "6a7c",
	"./staple_stripe.jpg": "7f6d",
	"./staple_tee.jpg": "2741",
	"./stone_wash.jpg": "d5cc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "34fe";